module.exports = __webpack_public_path__ + "static/media/proj14_img1.fefd3f98.jpg";